import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationEventCategory } from '../../enums/notification-event-category.enum';
import { NotificationEventResult } from '../../enums/notification-event-result.enum';
import { NotificationHistoryEntry } from '../../models/notification-history-entry';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-notification-history-detail-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatIconModule, DatePipe, TranslateModule, MatButtonModule],
  templateUrl: './notification-history-detail-dialog.component.html',
  styleUrl: './notification-history-detail-dialog.component.scss',
})
export class NotificationHistoryDetailDialogComponent {
  entry = inject<NotificationHistoryEntry>(MAT_DIALOG_DATA);

  readonly Result = NotificationEventResult;
  readonly Category = NotificationEventCategory;
  readonly failureReasonByEmail = this.buildFailureReasonMap();

  private buildFailureReasonMap(): Map<string, string> {
    const map = new Map<string, string>();
    if (!this.entry.errorMessage) return map;

    for (const line of this.entry.errorMessage.split('\n')) {
      const colonIndex = line.indexOf(': ');
      if (colonIndex !== -1) {
        map.set(line.substring(0, colonIndex), line.substring(colonIndex + 2));
      }
    }
    return map;
  }
}
